import { useEffect, useRef, useState } from 'react';

const extractReferenceIds = (selections) =>
  Array.from(
    new Set(
      (selections || [])
        .map((selection) => (selection?.referenceId != null ? String(selection.referenceId).trim() : ''))
        .filter((value) => value.length > 0)
    )
  );

export const useDiHydration = ({ selections, fetchDiOrderItemsByReferenceId, setSnackbar }) => {
  const [diByReferenceId, setDiByReferenceId] = useState({});
  const [diErrorShown, setDiErrorShown] = useState(false);
  const diLoadedRefsRef = useRef(new Set());

  // DI (AppSheet) enrichment for the drawer grid: fetch SF_GM OrderItems rows by referenceId.
  // Already-loaded reference IDs are memoized so tab switches do not keep refetching
  // the same AppSheet rows while the drawer stays open.
  useEffect(() => {
    let mounted = true;
    const run = async () => {
      const refs = extractReferenceIds(selections);
      if (!refs.length) return;
      const missing = refs.filter((ref) => !diLoadedRefsRef.current.has(ref));
      if (!missing.length) return;
      try {
        const result = await fetchDiOrderItemsByReferenceId(missing);
        const byRef = result?.byReferenceId || {};
        missing.forEach((ref) => diLoadedRefsRef.current.add(ref));
        if (!mounted) return;
        setDiByReferenceId((prev) => ({ ...(prev || {}), ...(byRef || {}) }));
      } catch (error) {
        if (!mounted) return;
        if (!diErrorShown) {
          setDiErrorShown(true);
          setSnackbar({
            open: true,
            message:
              error?.response?.data?.message ||
              error?.message ||
              'Failed to load DI fields (AppSheet cache unavailable).',
            severity: 'warning',
          });
        }
      }
    };
    run();
    return () => {
      mounted = false;
    };
  }, [selections, fetchDiOrderItemsByReferenceId, diErrorShown, setSnackbar]);

  return {
    diByReferenceId,
  };
};
